export default {
    FETCHED_NOTIFICATION_TEMPLETE: 'FETCHED_NOTIFICATION_TEMPLETE',
    FETCHED_NOTIFICATION_TEMPLETE_ERROR: 'FETCHED_NOTIFICATION_TEMPLETE_ERROR',
    FETCHED_NOTIFICATION_TEMPLETE_LOADING: 'FETCHED_NOTIFICATION_TEMPLETE_LOADING',
    
    NOTIFICATION_TEMPLETE_ENTRY: "NOTIFICATION_TEMPLETE_ENTRY",
    NOTIFICATION_TEMPLETE_ENTRY_ERROR: "NOTIFICATION_TEMPLETE_ENTRY_ERROR",
    NOTIFICATION_TEMPLETE_ENTRY_LOADING: "NOTIFICATION_TEMPLETE_ENTRY_LOADING",

}